import React, { Fragment, useState } from 'react';

import { Dialog } from '@material-ui/core';

import {
  MobiCopilotGreenIcon,
  Z_INDEX_COMPONENT_LEVEL,
} from 'modules/mobiCopilot/utils/constants';
import { formatTimestamp } from 'modules/mobiCopilot/utils/functions';
import { DefaultMessage } from 'modules/mobiCopilot/utils/interfaces';

import { LoadingDots } from './LoadingDots';
import { MarkdownRenderer } from './MarkdownRenderer';

import * as S from './styles';

interface Props extends Omit<DefaultMessage, 'id' | 'timestamp'> {
  isFullScreen: boolean;
  pendingSocketResponse?: boolean;
  timestamp?: number;
  userInitials?: string;
}

export function Message({
  content,
  isFullScreen,
  pendingSocketResponse = false,
  sender,
  timestamp,
  type,
  userInitials = '--',
}: Props) {
  const [previewImageDialog, setPreviewImageDialog] = useState(false);

  const messageTimestamp = formatTimestamp({ timestamp, format: 'HH:mm' });

  const getImageInfo = () => {
    let info = 'Mensagem ';

    if (sender === 'client') info += 'enviada';
    if (sender === 'server') info += 'recebida';

    if (messageTimestamp) info += ` às ${messageTimestamp}`;

    return info;
  };

  return (
    <Fragment>
      <S.Container data-is-fullscreen={isFullScreen} data-sender={sender}>
        <S.Avatar data-sender={sender}>
          {sender === 'client' && userInitials}
          {sender === 'server' && <MobiCopilotGreenIcon />}
        </S.Avatar>
        <S.Content data-sender={sender}>
          {pendingSocketResponse && <LoadingDots />}
          {!pendingSocketResponse && (
            <Fragment>
              {type === 'default' && <MarkdownRenderer content={content} />}
              {type === 'image' && (
                <img
                  src={content}
                  alt={getImageInfo()}
                  title={getImageInfo()}
                  onClick={() => setPreviewImageDialog(true)}
                />
              )}
              <S.Timestamp className="timestamp">
                {messageTimestamp}
              </S.Timestamp>
            </Fragment>
          )}
        </S.Content>
      </S.Container>
      {type === 'image' && (
        <Dialog
          maxWidth="lg"
          open={previewImageDialog}
          onClose={() => setPreviewImageDialog(false)}
          style={{ zIndex: Z_INDEX_COMPONENT_LEVEL }}
        >
          <img src={content} alt={getImageInfo()} title={getImageInfo()} />
        </Dialog>
      )}
    </Fragment>
  );
}
